import React, { useEffect } from 'react';
import DetailMREPoleTable from '../components/DetailMREPoleTable';
import DetailMREForm from '../components/DetailMREForm';
import { useAppDispatch, useAppSelector } from '../../../../../helpers/redux';
import { RootState } from '../../../../../app/store';
import { JobID } from '../../jobDetail/models';
import { isObjectEmpty } from '../../../../../helpers/checkEmptiness';
import {
    getDetailPoleMRE,
    getDetailPoleQCMRE,
    getPoleMREByJobForLog,
    reset,
    setShowAddMrePoleLogModal,
} from '../../../../basic/pole/pole.reducer';
import DetailQCMREForm from '../components/DetailQCMREForm';
import AddMREPoleTable from '../components/AddMREPoleTable';
import { useParams } from 'react-router-dom';
import { HttpClientError, RequestStatus } from 'http-client';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { deletedStatusOption, savedStatusOption } from 'helpers/alertLabel';
import DetailQCMREPoleTable from '../components/DetailQCMREPoleTable';

const DetailMREPage = () => {
    const MySwal = withReactContent(Swal);
    const dispatch = useAppDispatch();
    const { id } = useParams();

    const status = useAppSelector(
        (state: RootState) => state.pole.deleteLogStatus
    );
    const addMrePoleLogStatus = useAppSelector(
        (state: RootState) => state.pole.addMrePoleLogStatus
    );
    const error = useAppSelector(
        (state: RootState) => state.pole.error ?? ({} as HttpClientError)
    );

    useEffect(() => {
        if (id && id !== '') {
            dispatch(
                getDetailPoleMRE({ job_id: id as string, skip: 0, take: 10 })
            );
            dispatch(
                getDetailPoleQCMRE({ job_id: id as string, skip: 0, take: 10 })
            );
            dispatch(
                getPoleMREByJobForLog({
                    job_id: id as string,
                    skip: 0,
                    take: 10000,
                })
            );
        }
    }, [id]);

    useEffect(() => {
        if (status !== undefined && status !== RequestStatus.pending) {
            MySwal.fire(
                deletedStatusOption(
                    status === RequestStatus.success,
                    error.data?.message
                )
            ).then(() => {
                dispatch(reset());
                dispatch(
                    getDetailPoleMRE({
                        job_id: id as string,
                        skip: 0,
                        take: 10,
                    })
                );
                dispatch(
                    getDetailPoleQCMRE({
                        job_id: id as string,
                        skip: 0,
                        take: 10,
                    })
                );
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status, error]);

    useEffect(() => {
        if (
            addMrePoleLogStatus !== undefined &&
            addMrePoleLogStatus !== RequestStatus.pending
        ) {
            MySwal.fire(
                savedStatusOption(
                    addMrePoleLogStatus === RequestStatus.success,
                    error.data?.message
                )
            ).then(() => {
                dispatch(reset());
                // return navigate('/worksheet/process/job-prep', {replace: true});
                dispatch(
                    getDetailPoleMRE({
                        job_id: id as string,
                        skip: 0,
                        take: 10,
                    })
                );
                dispatch(
                    getDetailPoleQCMRE({
                        job_id: id as string,
                        skip: 0,
                        take: 10,
                    })
                );
                dispatch(setShowAddMrePoleLogModal(false));
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addMrePoleLogStatus, error]);

    return (
        <div className="p-2 md:p-10 bg-white dark:border-gray-700 dark:bg-gray-800 rounded-2xl">
            <div className="mt-3">
                <div>
                    <AddMREPoleTable />
                    <div className="my-3">
                        <hr />
                    </div>
                    <DetailQCMREPoleTable jobId={id as string} />
                    <div className="my-3">
                        <hr />
                    </div>
                    <DetailMREPoleTable jobId={id as string} />
                </div>
                <div>
                    <DetailMREForm jobId={id as string} />
                    <div className="my-3">
                        <hr />
                    </div>
                    <DetailQCMREForm jobId={id as string} />
                </div>
            </div>
        </div>
    );
};

export default DetailMREPage;
